export default "__VITE_ASSET__0eaf2a90__"